// import React from "react";
// import ReactModal from "react-modal";

// ReactModal.setAppElement("#root"); // Ensure accessibility by linking to your app root element

// const Modal = ({ isOpen, onRequestClose, title, children }) => {
//   return (
//     <ReactModal
//       isOpen={isOpen}
//       onRequestClose={onRequestClose}
//       contentLabel={title}
//       overlayClassName="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center"
//       className="bg-white rounded-lg shadow-xl p-6 w-full max-w-md mx-auto relative"
//     >
//       <div className="border-b pb-2 mb-4">
//         <h2 className="text-xl font-semibold">{title}</h2>
//       </div>
//       <div
//         className="overflow-y-auto max-h-[60vh] px-1.5 py-1"
//         style={{ scrollbarWidth: "thin" }} // For consistent thin scrollbar
//       >
//         {children}
//       </div>
//     </ReactModal>
//   );
// };

// export default Modal;

// import ReactModal from "react-modal";

// ReactModal.setAppElement("#root");

// const Modal = ({ isOpen, onRequestClose, title, children, fullSize = false }) => {
//   return (
//     <ReactModal
//       isOpen={isOpen}
//       onRequestClose={onRequestClose}
//       contentLabel={title}
//       overlayClassName="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-end md:items-center z-50 backdrop-blur-sm"
//       className={`bg-white font-poppins dark:bg-gray-950 dark:border dark:border-gray-700 shadow-xl p-6 mx-auto relative transition-transform duration-300 transform md:animate-none animate-slideUp ${
//         fullSize
//           ? "w-full h-full rounded-none md:rounded-none"
//           : "w-full max-w-md rounded-t-lg md:rounded-lg"
//       }`}
//     >
//       <div className="flex items-center justify-between border-b dark:border-gray-700 pb-2 mb-4">
//         <h2 className="text-xl font-semibold dark:text-white">{title}</h2>
//         <button
//           type="button"
//           onClick={onRequestClose}
//           className="px-4 py-2 hover:text-red-500 hover:bg-gray-100 text-gray-700 dark:bg-gray-900 rounded-md"
//         >
//           X
//         </button>
//       </div>
//       <div
//         className={`overflow-y-auto ${
//           fullSize ? "h-[calc(100%-3rem)]" : "max-h-[60vh]"
//         } px-1.5 py-1`}
//         style={{ scrollbarWidth: "thin" }}
//       >
//         {children}
//       </div>
//     </ReactModal>
//   );
// };

// export default Modal;


import ReactModal from "react-modal";
import { X } from "lucide-react";

ReactModal.setAppElement("#root");

const Modal = ({ isOpen, onRequestClose, title, children, fullSize = false }) => {
  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel={title}
      overlayClassName="fixed inset-0 bg-black/60 flex justify-center items-end md:items-center z-50 backdrop-blur-md transition-all duration-300"
      className={`bg-white/95 backdrop-blur-xl font-poppins dark:bg-gray-900/95 dark:backdrop-blur-xl border border-gray-200/50 dark:border-gray-700/50 shadow-2xl relative transition-all duration-500 transform ${
        fullSize
          ? "w-full h-full"
          : "w-full max-w-3xl min-w-lg mx-4 md:mx-auto rounded"
      } ${
        isOpen 
          ? "translate-y-0 opacity-100 scale-100" 
          : "translate-y-full md:translate-y-0 opacity-0 scale-95"
      }`}>
        
      {/* Header with gradient background */}
      <div className="relative">
        <div className="absolute inset-0 bg-gradient-to-r from-blue-50 to-purple-50 dark:from-gray-800 dark:to-gray-850"></div>
        <div className="relative flex items-center justify-between p-6 border-b border-gray-200/50 dark:border-gray-700/50">
          <div className="flex items-center space-x-3">
            <div className="w-1 h-6 bg-gradient-to-b from-blue-500 to-purple-600 rounded-full"></div>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white tracking-tight">
              {title}
            </h2>
          </div>
          
          {/* Enhanced close button */}
          <button
            type="button"
            onClick={onRequestClose}
            className="group relative p-2 rounded-xl bg-gray-100/80 hover:bg-red-50 dark:bg-gray-800/80 dark:hover:bg-red-900/20 transition-all duration-200 hover:scale-105 active:scale-95"
            aria-label="Close modal"
          >
            <X 
              size={20} 
              className="text-gray-600 group-hover:text-red-500 dark:text-gray-400 dark:group-hover:text-red-400 transition-colors duration-200" 
            />
            <div className="absolute inset-0 rounded-xl bg-gradient-to-br from-red-500/0 to-red-600/0 group-hover:from-red-500/10 group-hover:to-red-600/10 transition-all duration-200"></div>
          </button>
        </div>
      </div>

      {/* Content area with custom scrollbar */}
      <div
        className={`relative overflow-y-auto ${
          fullSize ? "h-[calc(100%-5rem)]" : "max-h-[70vh]"
        } p-6`}
        style={{ 
          scrollbarWidth: "thin",
          scrollbarColor: "#cbd5e1 transparent"
        }}
      >
        {/* Custom scrollbar styles for webkit browsers */}
        <style jsx>{`
          div::-webkit-scrollbar {
            width: 6px;
          }
          div::-webkit-scrollbar-track {
            background: transparent;
          }
          div::-webkit-scrollbar-thumb {
            background: linear-gradient(to bottom, #cbd5e1, #94a3b8);
            border-radius: 3px;
          }
          div::-webkit-scrollbar-thumb:hover {
            background: linear-gradient(to bottom, #94a3b8, #64748b);
          }
          .dark div::-webkit-scrollbar-thumb {
            background: linear-gradient(to bottom, #4b5563, #374151);
          }
          .dark div::-webkit-scrollbar-thumb:hover {
            background: linear-gradient(to bottom, #6b7280, #4b5563);
          }
        `}</style>
        
        {/* Content wrapper with subtle animation */}
        <div className="animate-in fade-in-50 duration-500 delay-100">
          {children}
        </div>
      </div>

      {/* Subtle bottom border for visual separation */}
      <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-blue-500/20 via-purple-500/20 to-pink-500/20 rounded-b-2xl"></div>
    </ReactModal>
  );
};

export default Modal;